module.exports = {"id":"%{id}","title":"%{title}","state":"%{state}","type":"tip","displayCondition":{"type":"true"},"condition":{"type":"true"},"operator":{"type":"sum_prices","charges":{"ids":["%{id}"]}}}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/ChargeV2.template.tip.json
// module id = 967
// module chunks = 0